export interface ServerEntity {
  active:     boolean;
  ownerId:      number;
  port:         number;
  serverDomain: string;
  serverId:     number;        // 保持为数字（原始 server_id）
  serverIp:     string;
  serverName:   string;
  ssl:          boolean;
  uuid:         string | null; // UUID 字段，用于API调用
}

export class Convert {
  public static toServerEntity(json: any): ServerEntity {
    return {
      active: Boolean(json.active || json.is_active),
      ownerId: Number(json.ownerId || json.owner_id),
      port: Number(json.port) || 0,
      serverDomain: json.serverDomain || json.server_domain || '',
      serverId: Number(json.serverId || json.server_id),  // 保持为数字
      serverIp: json.serverIp === 'null' ? '' : (json.serverIp || json.server_ip || ''),
      serverName: json.serverName || json.server_name || '',
      ssl: Boolean(json.ssl),
      uuid: json.uuid || null  // 保留 UUID 字段用于API调用
    };
  }

  public static serverEntityToJson(value: ServerEntity): string {
    return JSON.stringify(value, null, 2);
  }
}
